export const MAX_GUEST_LINK_EMAILS_BATCH = 25;
